<template>
  <Dialog :show="dialogVisible" @close="$event => closeDialog()">
    <div class="dialog-box content-box-plus child p-3">
      <div class="title">Confirm</div>
      <div class="description pb-2">{{ message }}</div>
      <div class="dialog-buttons button">
        <div class="btn btn-egx-white" @click="$event => closeDialog()" :disabled="isDeleting">Cancel</div>
        <div class="btn btn-egx" @click="$event => handleSave()" :disabled="isDeleting">
          <span v-if="!isDeleting">Yes</span>
          <font-awesome-icon
            :icon="['fa', 'circle-notch']"
            class="fa-spin m-auto spinner"
            v-else
          />
        </div>
      </div>
    </div>
  </Dialog>
</template>
<script>
import Dialog from '../Dialog.vue';

export default {
  components: {
    Dialog,
  },

  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    isDeleting: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeDialog() {
      if(!this.isDeleting) { this.$emit('close'); }
    },
    handleSave() {
      if(!this.isDeleting) { this.$emit('save'); }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/stylesheets/components/project/confirm-dialog.scss';
</style>
